



















































import { Component, Vue, Prop } from 'vue-property-decorator';

import Typography from '@/components/atoms/Typography/Typography.vue';

export type Tab = {
  key: string;
  label: string;
};

@Component({
  components: {
    Typography
  }
})
export default class Tabs extends Vue {
  @Prop() tabs!: Tab[];
  @Prop({ default: '' }) activeTabKey?: string;
  @Prop({ default: true }) responsive?: boolean;
  @Prop({ default: false }) disabled?: boolean;

  get activeTabPosition() {
    const tabIndex = this.tabs.findIndex(tab => tab.key === this.activeTabKey);

    if (tabIndex === 0) {
      return 'first';
    }

    if (tabIndex === this.tabs.length - 1) {
      return 'last';
    }

    return 'middle';
  }

  isActive(tabKey: string) {
    return this.activeTabKey === tabKey;
  }
}
